import SettingBase from '../settings/util/SettingBase'

class ItemTypeController extends SettingBase {
  /*@ngInject*/
  constructor($state) {
    super();
    this.$state = $state
    this.id = "items-type"
    this.acl = {}
    this.hasACL = {}

  }
  $onInit() {
    super.$onInit()
    for (let key in this.acl['setting-' + this.id]) {
      this.hasACL[this.acl['setting-' + this.id][key]] = true;
    }
  }
}

export default ItemTypeController;


// WEBPACK FOOTER //
// ./client/app/components/item_type/item_type.controller.js